const state = {
    selectedB2bId: null,
};
//gettters
const getters = {


    GET_SELECTED_B2BID: (state) => {
        return state.selectedB2bId;
    }
};
//actions
const actions = {
    CLEAR_MANAGE_AGENT_STORE: ({ commit }) => {
        commit('clearManageAgentStore');
    },
    SET_SELECTED_B2BID: ({ commit }, selectedB2bId) => {
        commit("saveSelectedB2bId", selectedB2bId);
    },

};
//mutations

const mutations = {
    clearManageAgentStore(state) {

        state.selectedB2bId = null;
    },



    saveSelectedB2bId(state, selectedB2bId) {
        state.selectedB2bId = selectedB2bId;
    },


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};